// react library imports
import { PlayCircle, PauseCircle  } from 'phosphor-react';
import { useRef, useState } from "react";

// style imports
import './VideoPlayer.css';

const VideoPlayer = ({src, thumbnail, className}) => {
    const videoRef = useRef(null);
    const [play, setPlay]=useState(true)
  
    const videoHandler = (control) => {
      if (control === "play") {
        videoRef.current.play();
        setPlay(false)
      } else if (control === "pause") {
        videoRef.current.pause();
        setPlay(true)
      }
    };
  return (
    <div className='video_play_container'>
      {play && <img src={thumbnail} alt="thumbnail" />}
      <video ref={videoRef} 
      src={src}
      className={!play ?"":"video_player"} loop/>
      <div className='video_controller_container'>
        {play ? 
        <PlayCircle className={`mues_pointer ${className}`} 
        weight='fill' onClick={() => videoHandler("play")}/>:<PauseCircle 
        className={`mues_pointer ${className}`} 
        weight='fill' onClick={()=>videoHandler("pause")}/>}
      </div>
    </div>
  )
}

export default VideoPlayer